<template>
  <div class="config-page" v-loading.fullscreen.lock="pageLoading" element-loading-text="加载中...">
    <!-- 积分基础配置 -->
    <div class="config-section">
      <div class="section-title">
        积分基础配置
        <el-button
          v-if="!baseEdit"
          type="primary"
          size="mini"
          @click="enterBaseEdit"
        >
          编辑
        </el-button>
      </div>

      <div class="form-row">
        <label class="form-label">积分自定义名称</label>
        <el-input
          v-model="baseForm.mallName"
          placeholder="积分"
          style="width: 160px"
          :readonly="!baseEdit"
        />
      </div>
      <div class="form-row">
        <label class="form-label">积分抵现比例</label>
        <div class="ratio-input">
          <el-input
            v-model="baseForm.exchangeRate"
            type="number"
            style="width: 100px"
            :readonly="!baseEdit"
          />
          <span class="unit">积分 = 1元</span>
        </div>
      </div>
      <div class="form-row">
        <label class="form-label">积分商城链接</label>
        <el-input
          v-model="baseForm.mallUrl"
          placeholder="URL H5"
          style="width: 250px"
          :readonly="!baseEdit"
        />
        <el-switch
            class="my-switch"
          v-model="baseForm.isHide"
          :active-value="1"
          :inactive-value="0"
          :disabled="!baseEdit"
        />
        <span class="tip-text">关闭则隐藏积分商城入口</span>
      </div>
      <div class="form-row">
        <label class="form-label">人员同步任务cron表达式</label>
        <el-input
          v-model="baseForm.userSyncCron"
          placeholder="如：0 0 2 * * ?"
          style="width: 250px"
          :readonly="!baseEdit"
        />
        <a 
          href="https://www.pppet.net/" 
          target="_blank" 
          class="cron-link"
          v-if="baseEdit"
        >生成器</a>
      </div>
      <div class="form-row">
        <label class="form-label">积分同步任务cron表达式</label>
        <el-input
          v-model="baseForm.syncCron"
          placeholder="如：0 0 2 * * ?"
          style="width: 250px"
          :readonly="!baseEdit"
        />
        <a 
          href="https://www.pppet.net/" 
          target="_blank" 
          class="cron-link"
          v-if="baseEdit"
        >生成器</a>
        <el-button 
          style="margin-left: 10px"
          type="primary" 
          size="mini"
          @click="updateTask"
          :disabled="baseEdit || !taskUpdateReady"
        >更新启动任务</el-button>
        <span
          class="task-tip"
          :class="{ 'is-ready': taskUpdateReady && !baseEdit }"
        >
          {{
            taskUpdateReady && !baseEdit
              ? "配置已保存，可以更新启动任务"
              : "请先编辑并保存人员同步、积分同步任务 cron 表达式"
          }}
        </span>
      </div>
      <div class="submit-wrap" v-if="baseEdit">
        <el-button @click="cancelBaseEdit">取消</el-button>
        <el-button type="success" @click="submitBaseConfig">确认</el-button>
      </div>
    </div>

    <!-- 积分来源配置 -->
    <div class="config-section">
      <div class="section-title">
        积分来源配置
        <span class="right-tip">新增积分来源并非实时生效，请联系技术管理员</span>
        <el-button
          v-if="!sourceEdit"
          type="primary"
          size="mini"
          @click="enterSourceEdit"
        >
          编辑
        </el-button>
      </div>

      <!-- 表头：严格对齐 -->
      <div class="source-header">
        <div class="col col-check"></div>
        <div class="col col-title">编码</div>
        <div class="col col-title">名称</div>
        <div class="col col-title">类型</div>
        <div class="col col-title">描述</div>
        <div class="col col-title">状态</div>
      </div>

      <!-- 列表：每一列严格对齐 -->
      <div class="source-list">
        <div class="source-item" v-for="(item, index) in sourceList" :key="item.id || index">
          <el-checkbox class="col col-check" v-model="item.checked" :disabled="!sourceEdit" />

          <el-input
            class="col"
            v-model="item.code"
            placeholder="编码"
            :readonly="!sourceEdit"
          />
          <el-input
            class="col"
            v-model="item.name"
            placeholder="名称"
            :readonly="!sourceEdit"
          />
          <el-select
            class="col"
            v-model="item.direction"
            :disabled="!sourceEdit"
            placeholder="请选择类型"
          >
            <el-option label="增加积分" :value="1" />
            <el-option label="消耗积分" :value="-1" />
          </el-select>
          <el-input
            class="col"
            v-model="item.description"
            placeholder="描述"
            :readonly="!sourceEdit"
          />
          <el-switch
            class="col"
            v-model="item.isActive"
            :active-value="1"
            :inactive-value="0"
            :disabled="!sourceEdit"
          />
        </div>
      </div>

      <el-button
        icon="el-icon-plus"
        circle
        type="success"
        class="add-btn"
        @click="addSourceRow"
        :disabled="!sourceEdit"
      />

      <div class="submit-wrap" v-if="sourceEdit">
        <el-button @click="cancelSourceEdit">取消</el-button>
        <el-button type="success" @click="addNewRow">新增本行</el-button>
        <el-button type="primary" @click="saveCheckedRow">保存勾选</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";

export default {
  name: "ScoreConfig",
  data() {
    return {
      pageLoading: false, // 整页loading状态
      baseEdit: false,
      taskUpdateReady: false,
      baseForm: {
        id: "",
        mallCode: "JD",
        mallName: "积分",
        partyName: "京东商城配置",
        exchangeRate: 1,
        isActive: 1,
        isHide: 1,
        mallUrl: "URL H5"
      },
      sourceEdit: false,
      sourceList: [],
      sourceBackup: []
    };
  },
  created() {
    this.getBaseData();
    this.getSourceList();
  },
  methods:{
    // 基础配置
    enterBaseEdit() {
      this.baseEdit = true;
      // 重新编辑配置后，必须再次确认保存才能更新启动任务
      this.taskUpdateReady = false;
    },
    async getBaseData() {
      this.pageLoading = true;

      try {
        const res = await api.getPointBaseSet({ page: 1, pageSize: 1 });
        const data = res.data?.list?.[0] || {};
        if (data) {
      this.pageLoading = false;

            this.baseForm = { ...this.baseForm, ...data }
        };
      } catch (err) {
      this.pageLoading = false;

        this.$message.error("获取基础配置失败");
      }
    },
    async submitBaseConfig() {
      if (!this.baseForm.mallName) {
        this.$message.warning("请输入积分名称");
        return;
      }
      if (!this.baseForm.userSyncCron || !this.baseForm.syncCron) {
        this.$message.warning("请填写人员同步和积分同步任务 cron 表达式");
        return;
      }
      this.pageLoading = true;
      try {
        await api.editPointBaseSet(this.baseForm);
        this.baseEdit = false;
        this.taskUpdateReady = true;
        this.$message.success("保存成功，现在可以更新启动任务");
      } catch (err) {
        this.$message.error("保存失败");
      } finally {
        this.pageLoading = false;
      }
    },
    cancelBaseEdit() {
      this.baseEdit = false;
      this.getBaseData();
    },
    async updateTask() {
      if (this.baseEdit || !this.taskUpdateReady) {
        this.$message.warning(
          "请先编辑并保存人员同步、积分同步任务 cron 表达式"
        );
        return;
      }
      this.pageLoading = true;
      try {
        await api.updateTask();
        this.taskUpdateReady = false;
        this.$message.success("任务更新成功");
      } catch (err) {
        this.$message.error("任务更新失败");
      } finally {
        this.pageLoading = false;
      }
    },

    // 积分来源
    async getSourceList() {
      try {
        const res = await api.getPointSet({ page: 1, pageSize: 999 });
        this.sourceList = res.data?.list || [];
        // 修复：第一次勾选没反应（Vue响应式）
        this.sourceList.forEach(item => {
          this.$set(item, 'checked', false);
        });
      } catch (err) {
        this.$message.error("获取积分来源失败");
      }
    },
    enterSourceEdit() {
      this.sourceBackup = JSON.parse(JSON.stringify(this.sourceList));
      this.sourceEdit = true;
    },
    cancelSourceEdit() {
      this.sourceEdit = false;
      this.getSourceList()
    },
    addSourceRow() {
      const newRow = {
        code: "",
        name: "",
        direction: 1,
        description: "",
        isActive: 0
      };
      this.$set(newRow, 'checked', false);
      this.sourceList.push(newRow);
    },

    // 新增本行
    async addNewRow() {
      const addRow = this.sourceList.find(x => !x.id && x.checked);
      if(!addRow) {
        this.$message.warning("请先勾选要新增的行");
        return;
      }
      if (!addRow.code || !addRow.name) {
        this.$message.warning("编码和名称不能为空");
        return;
      }
      this.pageLoading = true;
      try {
        const params = {...addRow};
        delete params.checked;
        await api.addPointSet(params);
        this.$message.success("新增成功");
        this.cancelSourceEdit()
      } catch (err) {
        this.$message.error("新增失败");
      } finally {
        this.pageLoading = false;
      }
    },

    // 保存勾选
    async saveCheckedRow() {
      const editRow = this.sourceList.find(x => x.id && x.checked);
      if(!editRow) {
        this.$message.warning("请先勾选要修改的已有数据行");
        return;
      }
      this.pageLoading = true;
      try {
        const params = {...editRow};
        delete params.checked;
        await api.updatePointSet(params);
        this.$message.success("修改成功");
        this.cancelSourceEdit()

      } catch (err) {
        this.$message.error("修改失败");
      } finally {
        this.pageLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.config-page {
  background: #fff;
  padding: 20px;
  .config-section {
    margin-bottom: 30px;
    .section-title {
      background: #eee;
      padding: 10px 16px;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .form-row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding-left: 80px;
      .form-label {
        width: 120px;
        font-size: 14px;
      }
      .ratio-input {
        display: flex;
        align-items: center;
        .unit {
          margin-left: 8px;
          font-size: 14px;
        }
      }
      .tip-text {
        margin-left: 12px;
        font-size: 12px;
        color: #666;
      }
      .cron-link {
        margin-left: 8px;
        font-size: 12px;
        color: #409eff;
        cursor: pointer;
        
        &:hover {
          text-decoration: underline;
        }
      }
      .task-tip {
        margin-left: 10px;
        font-size: 12px;
        color: #e6a23c;

        &.is-ready {
          color: #67c23a;
        }
      }
    }
.my-switch{
    margin-left: 10px;
}
    /* --------------- 积分来源 对齐优化 --------------- */
    .source-header {
      display: flex;
      padding-left: 100px;
      margin-bottom: 10px;
      font-size: 14px;
      align-items: center;
    }
    .source-list {
      .source-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        padding-left: 100px;
      }
    }

    /* 统一列宽，实现完美对齐 */
    .col {
      width: 160px;
      margin-right: 20px;
    }
    .col-check {
      width: 60px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .col-title {
      font-weight: 500;
    }

    .add-btn {
      margin-left: 100px;
    }
  }
  .right-tip {
    font-size: 12px;
    color: #666;
    font-weight: normal;
  }
  .submit-wrap {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
